<template>
  <div class="container-xxl flex-grow-1 container-p-y">
    <div class="row mt-4">
      <div class="col-md-8 col-12">
        <button type="button" class="card mb-3 text-start text-dark text-decoration-none border-0 w-100 shadow-sm"
          style="cursor: pointer;">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h4 class="card-title mb-0 text-primary">Service Interruption</h4>
              <span class="badge bg-primary">New</span>
            </div>

            <p class="card-text mb-4">
              A service interruption has been reported in the Antakya area since 7:00 AM.
            </p>

            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-category me-2"></i>
                <small>Type: Technical</small>
              </div>

              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-calendar-time me-2"></i>
                <small>2025-04-30 10:15</small>
              </div>
            </div>
          </div>
        </button>
        <button type="button" class="card mb-3 text-start text-dark text-decoration-none border-0 w-100 shadow-sm"
          style="cursor: pointer;">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h4 class="card-title mb-0 text-primary">Service Interruption</h4>
              <span class="badge bg-primary">New</span>
            </div>

            <p class="card-text mb-4">
              A service interruption has been reported in the Antakya area since 7:00 AM.
            </p>

            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-category me-2"></i>
                <small>Type: Technical</small>
              </div>

              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-calendar-time me-2"></i>
                <small>2025-04-30 10:15</small>
              </div>
            </div>
          </div>
        </button>
        <button type="button" class="card mb-3 text-start text-dark text-decoration-none border-0 w-100 shadow-sm"
          style="cursor: pointer;">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h4 class="card-title mb-0 text-primary">Service Interruption</h4>
              <span class="badge bg-primary">New</span>
            </div>

            <p class="card-text mb-4">
              A service interruption has been reported in the Antakya area since 7:00 AM.
            </p>

            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-category me-2"></i>
                <small>Type: Technical</small>
              </div>

              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-calendar-time me-2"></i>
                <small>2025-04-30 10:15</small>
              </div>
            </div>
          </div>
        </button>
        <button type="button" class="card mb-3 text-start text-dark text-decoration-none border-0 w-100 shadow-sm"
          style="cursor: pointer;">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h4 class="card-title mb-0 text-primary">Service Interruption</h4>
              <span class="badge bg-primary">New</span>
            </div>

            <p class="card-text mb-4">
              A service interruption has been reported in the Antakya area since 7:00 AM.
            </p>

            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-category me-2"></i>
                <small>Type: Technical</small>
              </div>

              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-calendar-time me-2"></i>
                <small>2025-04-30 10:15</small>
              </div>
            </div>
          </div>
        </button>
        <button type="button" class="card mb-3 text-start text-dark text-decoration-none border-0 w-100 shadow-sm"
          style="cursor: pointer;">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-start mb-2">
              <h4 class="card-title mb-0 text-primary">Service Interruption</h4>
              <span class="badge bg-primary">New</span>
            </div>

            <p class="card-text mb-4">
              A service interruption has been reported in the Antakya area since 7:00 AM.
            </p>

            <div class="d-flex justify-content-between">
              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-category me-2"></i>
                <small>Type: Technical</small>
              </div>

              <div class="d-flex align-items-center text-muted">
                <i class="ti ti-calendar-time me-2"></i>
                <small>2025-04-30 10:15</small>
              </div>
            </div>
          </div>
        </button>
      </div>
      <div class="col-md-4 col-12 d-md-block d-none">
        <div class="card">
          <img class="card-img" src="@/assets/img/elements/4.jpg" alt="Card image cap" />
        </div>
      </div>
    </div>

  </div>
</template>
<script>

</script>
